export default "__VITE_ASSET__DG7ozHUt__"